var ProductModule = (function () {
    function ProductModule() {
    }
    return ProductModule;
}());
export { ProductModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product.module.ts.pre-build-optimizer.js